// extracted by mini-css-extract-plugin
export default {"card":"ProductCard_card__Okf1l","card__img":"ProductCard_card__img__MsxkO","card__content":"ProductCard_card__content__EHAVf"};